import { useState } from 'react';
import { TextField, Button, Banner, Spinner } from '@shopify/polaris';

export function SecretField(props) {
  const [visible, setVisible] = useState(false);
  return <TextField {...props} autoComplete={props.autoComplete || 'new-password'} type={visible ? 'text' : 'password'}
    connectedRight={<Button accessibilityLabel={`${visible ? 'Hide' : 'Show'} ${props.label}`} onClick={() => setVisible(!visible)}>{visible ? 'Hide' : 'Show'}</Button>} />;
}

export function SettingsFeedback({ error, success, retry }) {
  return <>{error && <Banner tone="critical" action={retry ? { content: 'Retry', onAction: retry } : undefined}>{error}</Banner>}
    {success && <Banner tone="success">{success}</Banner>}</>;
}

export function SettingsLoading() { return <div className="settings-loading"><Spinner accessibilityLabel="Loading settings" size="small" /></div>; }
